var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193,
    height: 77,
    viewBox: "0 0 193 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10.04 10.12V10c.013-.034.14-.184.223-.291.083-.107.202-.271.346-.488.29-.433.68-1.08 1.069-1.924a16.98 16.98 0 001.306-4.255C8.22 1.174 4.584.234 4.584.234 6.384 8.324.001 14.65.001 14.65c3.406-1.084 6.801-1.723 9.914-1.904.06-.843.102-1.712.126-2.627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M19.368 5.582C12.226 1.607 4.67.217 4.67.217 5.02 7.255.218 11.35.218 11.35c11-3.447 20.933-.319 23.472 4.775.948-2.24-1.411-7.98-4.322-10.542"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M23.268 6.762l.38.005c.01.001 1.448.022 3.59.283a13.233 13.233 0 00-.868-2.136C16.182.976 2.9.14 2.9.14c.816 6.655.035 10.663-2.734 17.193 9.335-4.242 16.477-4.157 21.566-2.44.784-2.563 1.232-4.98 1.5-7.753l.037-.377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M16.083 7.91v.066c-.003.73-.106 1.43-.34 2.052-2.777-2.085-7.817-3.55-15.412-.159l-.091.046.055-.078C2.49 6.622 2.912 3.877 2.441.11c0 0 6.316.092 12.18 2.321.794 1.514 1.455 3.597 1.462 5.479z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M29.386 13.008c-.002-.76-.048-1.52-.137-2.271a30.15 30.15 0 00-3.738-.226c-4.178 0-9.103.777-14.677 2.64-.143.047-.78.264-.78.264s.156-.662.187-.805c1.065-4.617 1.835-7.95 2.284-11.37C7.043.3 2.925.03 2.925.03 3.785 7.365 2.998 11.803.078 19l-.028.07.055-.03c6.903-3.277 12.656-4.227 17.322-3.856a156.83 156.83 0 014.258-.873 211.61 211.61 0 017.701-1.303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M23.799 15.338H2.134C.08 12.13.201 8.524.201 8.524c2.934-1.756 11.262-3.9 18.56-5.29C28.173 1.441 39.345.241 39.345.241l1.713.231-.288 1.231C28.56 4.44 28.03 11.618 23.8 15.338z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M1.097 11.64C4.569 7.192 7.035 3.45 15.219 1.477L15.465.24S10.49.775 4.384 1.663C3.82 5.27 2.465 9.32.163 12.682c.34-.307.59-.601.934-1.043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M5.386 3.75c-1.565-.845-3.53-.845-5.284 0L.43.767c1.755-.846 3.72-.846 5.286 0-.109.995-.222 1.989-.33 2.983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M5.409 3.686c-1.567-.844-3.535-.844-5.289 0C.232 2.692.344 1.698.454.702c1.755-.844 3.72-.844 5.285 0-.109.996-.221 1.99-.33 2.984z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M.018.017h3.748V4H.018z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "99.13%",
    x2: "6.608%",
    y1: "-5.914%",
    y2: "96.835%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E6E542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#009C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "75.42%",
    x2: "22.766%",
    y1: "38.939%",
    y2: "74.302%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E6E542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#009C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "75.641%",
    x2: "4.311%",
    y1: "27.603%",
    y2: "72.902%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E6E542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#009C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "98.494%",
    x2: "92.829%",
    y1: "49.937%",
    y2: "51.308%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E6E542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#009C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "76.689%",
    x2: "6.06%",
    y1: "29.154%",
    y2: "74.994%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E6E542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#009C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "27.897%",
    x2: "52.649%",
    y1: "24.337%",
    y2: "53.077%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#91C33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#15A748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: "88.196%",
    x2: "11.798%",
    y1: "29.028%",
    y2: "78.239%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E8E425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5EB245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: "86.469%",
    x2: "84.245%",
    y1: "47.069%",
    y2: "47.608%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E8E425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5EB245"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: "86.144%",
    cy: "74.317%",
    r: "33.765%",
    fx: "86.144%",
    fy: "74.317%",
    gradientTransform: "matrix(.24199 0 0 .9995 .653 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009C49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#90C351"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009C49",
    d: "M33.878 41.03c-1.493 0-3.47 1.524-3.406 5.17.031 1.762.613 2.57 1.69 2.57 1.015 0 1.843-.508 2.834-1.824.105-.836.724-4.81.92-5.557-.452-.21-1.082-.358-2.038-.358zm6.128 3.527c-.734 4.123-1.003 5.887-.98 7.172.004.268.04.597.105.926-.748-.03-1.554-.03-2.033-.03-.448 0-1.434 0-1.911.03a11.68 11.68 0 01-.183-1.883l-.01-.568c-1.077 1.644-2.372 2.809-4.165 2.809-3.167 0-5.058-2.212-5.12-5.737-.09-5.14 3.587-10.28 9.234-10.28.987 0 2.038.36 2.668.508.6.15 1.288.15 1.646.15.36 0 1.014-.121 1.312-.209h.688c-.5 2.27-.817 4.6-1.251 7.112zm13.014 2.6c-1.122 2.45-2.188 4.722-3.455 7.5-1.469 3.168-4.078 4.273-6.798 4.273-.897 0-2.157-.24-2.7-.567.219-1.136.608-2.84.714-3.677.448.09 1.527.21 2.363.21 1.285 0 1.79-.21 2.047-.867l.545-1.284c-.606-2.212-2.949-13.18-3.375-15.3.39.029 1.824.029 2.362.029.329 0 2.39 0 2.78-.029.426 2.241 1.13 6.604 1.387 9.293h.089c.544-1.376.889-2.211 1.546-3.855 1.204-2.989 1.57-4.244 1.877-5.438.45.029 2.093.029 2.632.029.536 0 2.09 0 2.45-.029-1.612 3.555-3.024 6.543-4.464 9.712m20.456-2.482c-.435 2.51-1.14 6.515-1.295 7.98-1.016-.03-1.674-.03-2.6-.03-1.017 0-1.704 0-2.39.03a380.934 380.934 0 001.478-7.83c.757-4.512 1.496-8.456 1.707-10.011-.42-.09-1.41-.299-2.426-.299-1.076 0-2.175.389-2.421 1.644-.03.09-.275 1.374-.33 1.643 1.344 0 2.092 0 3.047-.058-.172.507-.7 2.809-.889 3.823-.389 0-.75-.03-1.406-.03-.657 0-1.046 0-1.315-.028-.815 4.63-1.75 9.383-1.778 11.146-.568-.03-2.063-.03-2.63-.03-.569 0-1.943 0-2.361.03.69-3.258 1.534-7.98 2.047-11.146-1.076 0-1.823 0-2.331.028.198-.656.601-3.256.651-3.793.24.028 1.286.028 2.393.058.104-.807.322-2.002.58-2.69.769-2.21 3.567-4.48 6.705-4.48 2.002 0 3.834.416 4.703.685 1.346 0 2.392 0 3.377-.03-.583 2.481-1.178 6.127-2.516 13.388M83.273 41c-1.672 0-3.345 1.883-3.293 4.842.033 1.882.626 3.287 2.449 3.287 1.912 0 3.368-2.183 3.32-4.961-.035-1.973-.802-3.168-2.476-3.168zm-1.58 12.193c-4.005 0-6.33-3.198-6.385-6.336-.1-5.737 3.89-9.92 8.611-9.92 3.736 0 6.383 2.689 6.448 6.394.092 5.319-3.682 9.862-8.675 9.862zm26.347-.538c-.567-.03-1.882-.03-2.27-.03-.301 0-2.42 0-2.75.03a556.21 556.21 0 01-.682-4.811c-.172-1.375-.376-2.78-.45-3.527h-.089c-.169.568-.83 2.122-1.521 3.586-1.009 2.092-2.106 4.333-2.217 4.752-.453-.03-2.187-.03-2.575-.03-.419 0-1.943 0-2.36.03-.135-.837-.55-4.064-.936-7.351-.352-3.02-.708-6.277-.824-7.859.417.029 2.332.029 2.808.029.48 0 1.794 0 2.211-.029.218 2.151.638 7.44.759 9.232h.15c.398-1.225 3.07-7.53 3.997-9.232.628.029 1.824.029 2.062.029.18 0 1.614 0 2.21-.029.139 1.075.286 2.599.43 4.004.184 2.062.463 4.363.567 5.139h.179a104.267 104.267 0 011.716-4.452c.687-1.704 1.375-3.377 1.98-4.69.45.028 1.495.028 1.943.028.388 0 2.211 0 2.48-.029-1.295 2.928-5.439 11.952-6.817 15.21m12.066-9.115c2.3-.06 3.337-.538 3.318-1.643-.012-.717-.53-1.285-1.637-1.285-1.553 0-2.732.955-3.055 2.957l1.374-.028zm-.035 3.168l-1.493.12c.054 1.344 1.058 2.33 2.91 2.33 1.614 0 3.252-.329 4.522-1.255h.088c-.05.538-.04 1.136-.03 1.732.01.48.018.958.054 1.376-1.23 1.374-3.098 2.182-5.877 2.182-4.065 0-6.36-3.078-6.416-6.276-.102-5.828 3.682-9.952 8.673-9.952 2.628 0 5.256 1.615 5.306 4.484.06 3.376-2.127 4.81-7.737 5.26zm19.225-4.513h-.09c-.331-.21-.662-.298-1.23-.298-1.106 0-2.203.509-3.43 2.031-.16 1.225-.27 1.793-.595 3.617-.38 2.211-.622 3.765-.747 5.11-.57-.03-2.064-.03-2.542-.03-.509 0-2.092 0-2.508.03.358-1.674.794-4.124 1.203-6.337.71-3.822 1.132-7.052 1.28-8.873.239.029 1.645.029 1.883.029.3 0 1.942 0 2.181-.029l.005.268c.01.626.022 1.285-.021 2.242h.03c1.576-2.153 2.702-2.75 4.076-2.75.776 0 1.107.09 1.53.328-.28 1.106-.807 3.378-1.025 4.662m-115.303.09c-.539 3.346-1.268 7.77-1.67 10.37-.3-.03-2.332-.03-2.632-.03-.358 0-2.061 0-2.33.03.44-2.212.868-5.08 1.33-7.741.407-2.39.754-4.722 1.032-5.946h-.09c-1.72 4.213-4.437 9.473-6.545 13.687-.568-.03-1.883-.03-2.241-.03-.27 0-1.704 0-2.241.03-.792-4.244-1.69-9.504-2.21-13.567h-.06c-.124 1.434-.638 4.481-1.127 7.261-.38 2.211-.846 4.542-1.085 6.306-.33-.03-1.526-.03-1.943-.03-.389 0-1.914 0-2.182.03.62-3.856 1.055-6.276 2.23-12.672.544-3.078.952-5.379 1.303-7.53.479.03 2.3.03 2.929.03.477 0 3.137 0 3.496-.03.522 2.48 1.832 10.788 2.155 13.926h.06c1.092-2.451 5.039-10.967 6.69-13.926.33.03 3.139.03 3.677.03.387 0 2.749 0 3.167-.03-.548 2.959-1.032 5.977-1.713 9.832"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.162 19.874)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M10.04 10.12V10c.013-.034.14-.184.223-.291.083-.107.202-.271.346-.488.29-.433.68-1.08 1.069-1.924a16.98 16.98 0 001.306-4.255C8.22 1.174 4.584.234 4.584.234 6.384 8.324.001 14.65.001 14.65c3.406-1.084 6.801-1.723 9.914-1.904.06-.843.102-1.712.126-2.627",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.396 18.655)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M19.368 5.582C12.226 1.607 4.67.217 4.67.217 5.02 7.255.218 11.35.218 11.35c11-3.447 20.933-.319 23.472 4.775.948-2.24-1.411-7.98-4.322-10.542",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.716 29.865)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M23.268 6.762l.38.005c.01.001 1.448.022 3.59.283a13.233 13.233 0 00-.868-2.136C16.182.976 2.9.14 2.9.14c.816 6.655.035 10.663-2.734 17.193 9.335-4.242 16.477-4.157 21.566-2.44.784-2.563 1.232-4.98 1.5-7.753l.037-.377",
    mask: "url(#i)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.917 36.932)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M-176.917 24.841h193v-46.704h-193z",
    mask: "url(#l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.237 34.495)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M29.386 13.008c-.002-.76-.048-1.52-.137-2.271a30.15 30.15 0 00-3.738-.226c-4.178 0-9.103.777-14.677 2.64-.143.047-.78.264-.78.264s.156-.662.187-.805c1.065-4.617 1.835-7.95 2.284-11.37C7.043.3 2.925.03 2.925.03 3.785 7.365 2.998 11.803.078 19l-.028.07.055-.03c6.903-3.277 12.656-4.227 17.322-3.856a156.83 156.83 0 014.258-.873 211.61 211.61 0 017.701-1.303",
    mask: "url(#o)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.162 46.436)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M-148.162 15.338h193v-46.704h-193z",
    mask: "url(#r)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.043 46.436)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M1.097 11.64C4.569 7.192 7.035 3.45 15.219 1.477L15.465.24S10.49.775 4.384 1.663C3.82 5.27 2.465 9.32.163 12.682c.34-.307.59-.601.934-1.043",
    mask: "url(#u)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.312 16.95)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M5.386 3.75c-1.565-.845-3.53-.845-5.284 0L.43.767c1.755-.846 3.72-.846 5.286 0-.109.995-.222 1.989-.33 2.983",
    mask: "url(#x)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.808 15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "A",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M-161.808 46.773h193V.07h-193z",
    mask: "url(#A)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00A84F",
    d: "M138.11 50.917c.26 0 .415-.127.415-.326v-.011c0-.21-.155-.326-.415-.326h-.519v.663h.52zm-.917-1.022h.934c.276 0 .492.083.636.226.11.105.17.255.17.437v.011c0 .337-.198.547-.485.63l.563.79h-.475l-.508-.724h-.437v.724h-.398v-2.094zM139.79 51v-.011c0-.989-.768-1.79-1.784-1.79a1.783 1.783 0 00-1.796 1.8v.012c0 .989.768 1.79 1.784 1.79A1.783 1.783 0 00139.79 51zm-3.79.01V51c0-1.089.884-2 2.006-2 1.121 0 1.994.9 1.994 1.989v.01c0 1.09-.884 2.001-2.006 2.001-1.121 0-1.994-.9-1.994-1.99z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177 58)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "C",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00A84F",
    d: "M1.996 1.926c.243 0 .388-.126.388-.324V1.59c0-.209-.145-.324-.388-.324h-.487v.66h.487zM1.136.909h.875c.259 0 .46.082.596.225a.6.6 0 01.16.434v.012a.614.614 0 01-.455.627l.528.786h-.446l-.476-.72h-.409v.72h-.373V.91zm2.434 1.1v-.011c0-.985-.72-1.783-1.673-1.783C.94.215.215 1.024.215 2.01v.01c0 .985.72 1.783 1.672 1.783.958 0 1.683-.809 1.683-1.793zm-3.552.01v-.01C.018.925.846.017 1.898.017c1.05 0 1.868.897 1.868 1.98v.012C3.766 3.092 2.938 4 1.886 4 .837 4 .019 3.103.019 2.02z",
    mask: "url(#C)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMay);
export default __webpack_public_path__ + "static/media/may.6d481644420f550e6fda22dde6326758.svg";
export { ForwardRef as ReactComponent };